<template>
  <div class="clubs">
    <span id="c-add-up">
      <ClubAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('clubs.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#c-add-up"
        />
      </template>
      <div class="row">
        <div class="flex md12">
          <va-input
            v-model="name"
            :label="$t('clubs.forms.nameLabel')"
            :placeholder="$t('clubs.forms.namePlaceholder')"
          />
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :data="clubs"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('clubs.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#c-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('clubs.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ClubAddUpdate from './ClubAddUpdate'
const perPage = 10
export default {
  name: 'clubs',
  components: {
    ClubAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.clubs.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.logo,
            path: 'clubs',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_club_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      clubs: [],
      page: 1,
      name: '',
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    clubs: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $busca: String = "%%",) {
        clubs: club(
          limit: $perPage,
          offset: $page,
          where: {name: {_ilike: $busca}},
          order_by: {id: asc}
        ) {
          id
          name
          logo
          championship {
            id
            name
          }
          id_api
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          busca: this.nameSearch,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($busca: String = "%%") {
        pages: club_aggregate(where: {name: {_ilike: $busca}}) {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          busca: this.nameSearch,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    nameSearch () {
      return '%' + this.name.trim() + '%'
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('clubs.headings.name'),
        width: '40%',
      }, {
        name: 'championship',
        title: this.$t('clubs.headings.category'),
        width: '40%',
        callback (value) {
          return value ? value.name : ''
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('clubs')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.clubs.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
